import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';

const GeneralForm = () => (
	<div>
		<Field
			type='text'
			name='label'
			customlabel='Commentaire'
			component={CustomInputTextComponent}
			required
		/>

		<Field
			type='number'
			name='order'
			customlabel='Ordre'
			component={CustomInputTextComponent}
			required
		/>
	</div>
);

export default GeneralForm;
